<template>
  <div>
    <a-table
      :row-selection="{selectedRowKeys, onChange: onSelectChange}"
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <div slot="option">
        <a style="margin-right: 10px;" @click="applyHandle">应用</a>
        <a @click="seeHandle">查看</a>
      </div>
    </a-table>

  </div>
</template>
<script>
const columns = [
  {
    title: '名称',
    dataIndex: 'one',
  },
  {
    title: '代码',
    dataIndex: 'two',
  },
];
export default {
  data(){
    return {
      selectedRowKeys: [],
      columns,
      list: []
    }
  },
  methods: {
    onSelectChange(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys;
    }
  },
}
</script>
<style lang="scss" scoped>

</style>